import React from 'react';
import { methodSteps } from '../data/landing';
export function FrameworkStrip() {
  return <ol className="mx-auto grid max-w-xl grid-cols-5 gap-1 sm:gap-3" aria-label="Pause, Observe, Reduce, Regulate, Recover" data-id="element-42" data-mp="21rhno4dykf15">
      {methodSteps.map(step => {
      const Icon = step.icon;
      return <li key={step.name} className="flex flex-col items-center gap-2" data-id="element-43" data-mp="2aqmmlbtfmadu">
            <span className={`grid h-12 w-12 place-items-center rounded-full text-white shadow-md sm:h-16 sm:w-16 ${step.circle}`} data-id="element-44" data-mp="2or7321bvju46">
              <Icon className="h-5 w-5 sm:h-7 sm:w-7" aria-hidden="true" data-id="element-45" data-mp="2kp2e3fwdflnv" />
            </span>
            <span className="text-[10px] font-black uppercase tracking-wide text-navy sm:text-xs" data-id="element-46" data-mp="2yg77i095bhpr">{step.name}</span>
          </li>;
    })}
    </ol>;
}